import { DoqFaceSvgProps } from '../types';

const SwimlaneError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <g clipPath="url(#clip0_2698_48869)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-swimlane-error">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#76D1A5"
        mask="url(#bottom-mask-swimlane-error)"
      />
      <mask
        id="mask0_3410_45369"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_3410_45369)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>
      <path
        d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
        fill="#2974C4"
      />
      <path
        d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
        fill="#2974C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159 200C153.078 200 147.907 203.217 145.141 208L150.056 208C152.253 205.545 155.446 204 159 204C162.554 204 165.747 205.545 167.944 208L172.859 208C170.093 203.217 164.922 200 159 200Z"
        fill="#2974C4"
      />
      <path
        d="M80 119C80 110.163 87.1634 103 96 103H224C232.837 103 240 110.163 240 119V143L232 127L224 143L216 127L208 143L200 127L192 143L184 127L176 143L168 127L160 143L152 127L144 143L136 127L128 143L120 127L112 143L104 127L96 143L88 127L80 143V119Z"
        fill="#500052"
      />
      <path d="M80 151H72V143H80V151Z" fill="#232F3E" />
      <path d="M248 143H240V151H248V143Z" fill="#232F3E" />
      <path d="M72 159H64V135H72V159Z" fill="#546477" />
      <path d="M256 135H248V159H256V135Z" fill="#546477" />
      <path
        d="M96 232C91.5817 232 88 235.582 88 240V251.5H96L96 232Z"
        fill="#2974C4"
        fillOpacity="0.5"
      />
      <path
        d="M96.5 232L96.5 251.5H106.062L106.062 248.912C103.749 248.473 102 246.441 102 244C102 241.239 104.239 239 107 239C109.761 239 112 241.239 112 244C112 246.738 109.799 248.962 107.07 249L107.07 251.5H150.947V248.11H140.125C139.568 248.11 139.117 247.655 139.117 247.094V241.064C139.117 240.503 139.568 240.048 140.125 240.048H162.412C162.969 240.048 163.42 240.503 163.42 241.064V247.094C163.42 247.655 162.969 248.11 162.412 248.11H151.955V251.5H199.835V248.159H191.656C189.497 248.159 187.746 246.395 187.746 244.219C187.746 242.043 189.497 240.279 191.656 240.279H208.139C210.298 240.279 212.049 242.043 212.049 244.219C212.049 246.395 210.298 248.159 208.139 248.159H200.843V251.5H232V240C232 235.582 228.418 232 224 232H96.5Z"
        fill="#2974C4"
        fillOpacity="0.5"
      />
      <path
        d="M232 252H200.843V256.276H203.14C203.697 256.276 204.149 256.73 204.149 257.291V259.848H220.04C220.291 257.868 221.97 256.338 224.003 256.338C226.211 256.338 228 258.14 228 260.364C228 262.588 226.211 264.39 224.003 264.39C221.964 264.39 220.282 262.852 220.038 260.864H204.149V263.421C204.149 263.982 203.697 264.436 203.14 264.436H200.843V284.5H232V252Z"
        fill="#2974C4"
        fillOpacity="0.5"
      />
      <path
        d="M232 285H200.843V288.82H208.909C211.146 288.82 212.959 290.646 212.959 292.9C212.959 295.154 211.146 296.98 208.909 296.98H191.766C189.529 296.98 187.716 295.154 187.716 292.9C187.716 290.646 189.529 288.82 191.766 288.82H199.835V285H151.955V288.982C153.913 289.242 155.425 290.93 155.425 292.974C155.425 295.197 153.636 297 151.429 297C149.221 297 147.432 295.197 147.432 292.974C147.432 290.914 148.967 289.216 150.947 288.976V285H111.907V289.007C113.784 289.337 115.212 290.988 115.212 292.974C115.212 295.197 113.422 297 111.215 297C109.008 297 107.219 295.197 107.219 292.974C107.219 290.857 108.84 289.122 110.899 288.96V285H96.5L96.5 304H224C228.418 304 232 300.418 232 296V285Z"
        fill="#2974C4"
        fillOpacity="0.5"
      />
      <path d="M88 252V284.5H96L96 252H88Z" fill="#2974C4" fillOpacity="0.5" />
      <path
        d="M88 285V296C88 300.418 91.5817 304 96 304L96 285H88Z"
        fill="#2974C4"
        fillOpacity="0.5"
      />
      <path
        d="M199.835 277.393V284.5H151.955V277.393H171.553V279.687C171.553 280.248 172.005 280.703 172.561 280.703H186.977C187.534 280.703 187.986 280.248 187.986 279.687V277.393H199.835Z"
        fill="#2974C4"
        fillOpacity="0.5"
      />
      <path
        d="M150.947 277.393V284.5H111.907V280.723L118.081 277.669C118.222 277.599 118.337 277.504 118.426 277.393H150.947Z"
        fill="#2974C4"
        fillOpacity="0.5"
      />
      <path
        d="M110.899 280.723V284.5H96.5L96.5 252H106.062L106.062 265.402H110.899V272.791L104.725 275.846C103.973 276.218 103.973 277.297 104.725 277.669L110.899 280.723Z"
        fill="#2974C4"
        fillOpacity="0.5"
      />
      <path
        d="M107.07 252L107.07 264.386H139.97C140.045 264.19 140.181 264.013 140.38 263.889L150.919 257.294L150.932 257.286L150.947 257.277V252H107.07Z"
        fill="#2974C4"
        fillOpacity="0.5"
      />
      <path
        d="M151.955 252V257.277C151.964 257.283 151.974 257.288 151.983 257.294L162.522 263.889C163.157 264.286 163.157 265.217 162.522 265.615L151.983 272.209C151.974 272.215 151.964 272.22 151.955 272.226V276.377H171.553V273.558C171.553 272.997 172.005 272.542 172.561 272.542H186.977C187.534 272.542 187.986 272.997 187.986 273.558V276.377H199.835V264.436H196.753C196.196 264.436 195.744 263.982 195.744 263.421V257.291C195.744 256.73 196.196 256.276 196.753 256.276H199.835V252H151.955Z"
        fill="#2974C4"
        fillOpacity="0.5"
      />
      <path
        d="M118.081 275.846C118.323 275.965 118.487 276.158 118.573 276.377H150.947V272.226C150.937 272.22 150.928 272.215 150.919 272.209L140.38 265.615C140.285 265.555 140.203 265.483 140.136 265.402H111.907V272.791L118.081 275.846Z"
        fill="#2974C4"
        fillOpacity="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_2698_48869">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { SwimlaneError };
